import TableHeader from "@tiptap/extension-table-header";

export const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute("colwidth");
          const value = colwidth ? colwidth.split(",").map((width) => parseInt(width, 10)) : null;
          return value;
        },
        renderHTML: (attributes) => {
          return {
            colwidth: attributes.colwidth ? attributes.colwidth.join(",") : null
          };
        }
      }
    };
  }
});
